import PropTypes from 'prop-types'
import { OtherPageQuery, fetchOtherSSRData } from '@layouts/other'
import { CustomPageQuery, CUSTOM_PAGE_QUERY } from '@layouts/custom-page'
import { useFeatureFlags, flags } from '@lib/feature-flags'
import { fetchSSRData } from '@lib/ssr-fetch'

function Other(props) {
  const { ssrDataCustom, ssrDataOther, ...restProps } = props
  const [isCustomPageEnabled] = useFeatureFlags([flags.FLAG_CUSTOM_PAGE])

  return isCustomPageEnabled
    ? <CustomPageQuery {...restProps} route="/adm/" ssrData={ssrDataCustom} />
    : <OtherPageQuery {...restProps} ssrData={ssrDataOther} />
}

Other.getInitialProps = async ({ query, asPath }) => {
  // Fetch both queries to handle feature flag toggling
  const route = '/adm/'
  const where = query.slug
    ? { route, slug: query.slug }
    : { route, slug_exists: false }

  const [customResult, otherResult] = await Promise.all([
    fetchSSRData({
      query,
      graphqlQuery: CUSTOM_PAGE_QUERY,
      variables: { where, preview: query.preview },
      transform: (data) => data?.customPageCollection?.items?.[0],
    }),
    fetchOtherSSRData({ query }),
  ])

  return {
    query,
    asPath,
    ssrDataCustom: customResult.data,
    ssrDataOther: otherResult.data,
  }
}

Other.propTypes = {
  ssrDataCustom: PropTypes.object,
  ssrDataOther: PropTypes.object,
}

export default Other
